import React, { Fragment } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import CloseIcon from '@mui/icons-material/Close';
import QueryService from '../../services/QueryService';
import CampaignService from '../../services/CampaignService';
import MessageService from '../../services/MsgService';
import { useHistory } from 'react-router';
import swal from 'sweetalert';


const DeleteModal = ({ openDeleteModal,
    setOpenDeleteModal,
    deleteValue,
    setDeleteValue,
    getQueryPage,
    from,
    setBodyMessageValue,
    setSubjectValue,
    setIncludeFeedback,
    setFeedBackValue,
    setSubjectValueInSpanish,
    setBodyValueInSpanish,
    setFeedBackValueInSpanish
}) => {

    let history = useHistory();

    const deleteQuery = () => {
        let objForSaved = {
            action: 'delete',
            result_id: deleteValue.id
        }
        // let objForSchool = {
        //     // action: 'delete',
        //         id: deleteValue.id
        // }
        let objforCampaign = {
            campaign_id: deleteValue.id
        }
        let objForBanner = {
            action: "delete",
            banner_id: deleteValue && deleteValue.id
        }
        if (from === "saved-query") {
            QueryService.deleteQuery(objForSaved)
                .then(data => {
                    setDeleteValue()
                    setOpenDeleteModal(false)
                    history.push('/recruiter/school-query')
                })
                .catch(error => {
                    getQueryPage();
                    setOpenDeleteModal(false);
                })
                .catch(error => {
                    setDeleteValue('');
                    setBodyMessageValue('');
                    setIncludeFeedback();
                    setSubjectValue('');
                    setFeedBackValue();
                    setFeedBackValueInSpanish();
                    setSubjectValueInSpanish();
                    setBodyValueInSpanish();

                    swal({
                        title: "Deleted!",
                        text: "Template has been deleted successfully",
                        icon: "success",
                        button: "OK",
                    });
                })
                .catch(error => {
                })
        }
    }
    return (
        <Fragment>
            <Modal
                isOpen={openDeleteModal}
                toggle={() => setOpenDeleteModal(false)}
                centered={true}
            >
                <ModalBody>
                    <div style={{ justifyContent: 'space-between', padding: '30px', alignItems: 'start', display: 'flex' }}>
                        <div>
                            <p style={{ marginLeft: '50px', fontSize: '16px', fontWeight: 'bold', wordBreak: 'break-all' }} className="no-margin-bottom color">
                                {`Are you sure you want to delete ${from !== "message-template" && deleteValue && deleteValue.name ? deleteValue.name : deleteValue && deleteValue.table_name ? deleteValue.table_name : ''}?`}
                            </p>
                        </div>
                        <div onClick={() => setOpenDeleteModal(false)} className="cursor">
                            <CloseIcon />
                        </div>
                    </div>
                    <div className="flex" style={{ justifyContent: 'center', gap: '30px', padding: '0 0 30px' }}>
                        <button
                            className="delete-yes-btn"
                            onClick={deleteQuery}
                        >
                            Yes
                        </button>
                        <button className="delete-no-btn" onClick={() => setOpenDeleteModal(false)}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
        </Fragment>
    )
}
export default DeleteModal